export const isQmrPage = () => {
    return window.location.pathname.includes('/admin/quote-model-revisions')
}
